import type SoldOutIndex from '@app/model/market_insight/SoldOutIndex';

// A class of 3 hotels or fewer has no value (null): average only the classes with a value.
// The GraphQL Double scalar sends each rate as a string, so convert it before the sum.
export const averageSoldOutRate = (indices: SoldOutIndex[]): number | null => {
	const rates = indices.map(soldOutIndex => soldOutIndex.rate).filter((rate): rate is number => rate != null).map(Number);
	if (rates.length === 0) return null;
	return rates.reduce((a, b) => a + b, 0) / rates.length;
};
